import {Chip, Stack, Typography} from '@mui/material';

export interface FishGroupRowCertificatesProps {
  label: string;
  icon?: JSX.Element;
  value: string[];
  options?: string[];
}

export const FishGroupRowCertificates = ({label, value}: FishGroupRowCertificatesProps): JSX.Element => {
  return (
    <Stack direction={'row'} alignItems={'center'}>
      <Stack direction={'row'} width={90} alignItems={'center'} spacing={0.5}>
        <Typography variant="body2" color={'secondary'}>
          {label}
        </Typography>
      </Stack>

      <Stack direction={'row'} sx={{flexWrap: 'wrap'}} gap={1}>
        {value &&
          value.map((item, index) => (
            <Chip
              variant="outlined"
              size="small"
              key={'chip' + index}
              sx={{height: 'inherit'}}
              label={
                <Typography variant="body3" color={'text.primary'} alignItems={'center'}>
                  {item}
                </Typography>
              }
            />
          ))}
      </Stack>
    </Stack>
  );
};
